import { InputNumber } from '@seiue/ui'
import { PaperQuestionReq } from 'packages/sdks-next/growp'
import React, { useContext } from 'react'
import { ScoreSettingProps } from '../types'
import styled from 'styled-components'
import { useAtom } from 'jotai'
import { focusedBlockAtom } from '@/features/test-paper/components/BlockList/atoms'
import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { precisionFormat } from 'packages/utils'
import { EditPaperContext } from '../../context'

export const ScoreInputNumber: React.FC<ScoreSettingProps> = ({
  block,
  question,
  onUpdateScore,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  const [focusedBlock, setFocusedBlock] = useAtom(focusedBlockAtom)
  return (
    <Wrapper>
      <InputNumber
        disabled={
          limitLevel > 1 || focusedBlock.state === BlockStateEnum.Editing
        }
        value={question.score ? precisionFormat(question.score) : undefined}
        stringMode={true}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          const ele = document.getElementById(`${block.id}`)
          if (ele) {
            if (focusedBlock.id !== block.id) {
              setFocusedBlock({
                id: block.id,
                state: BlockStateEnum.Selected,
              })
            }
            ele.scrollIntoView({ block: 'center', behavior: 'smooth' })
          }
        }}
        onChange={(e) => {
          const v = precisionFormat(e)
          let totalScore = 0
          const newQuestions: PaperQuestionReq[] =
            block.questions?.map((q) => {
              if (q.id === question.id) {
                totalScore += v ? Number(v) : 0
                return {
                  ...q,
                  score: v ? String(v) : undefined,
                }
              } else if (q.parentId !== 0) {
                totalScore += q.score ? Number(q.score) : 0
              }
              return q
            }) || []
          newQuestions.splice(0, 1, {
            ...newQuestions[0],
            score: String(totalScore),
          })
          onUpdateScore(block.id, {
            ...block,
            questions: newQuestions || [],
          })
        }}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  &&& {
    .ant-input-number-input {
      width: 85px;
      height: 32px;
    }
  }
`
